// extracted by mini-css-extract-plugin
module.exports = {"productGrid":"dv","centerLink":"ev","productSection":"fv","item":"gv","ctaButton":"hv"};